// extracted by mini-css-extract-plugin
export default {"creationButtons":"promotions_creationButtons__sB4Nn"};